export const CONTENT_STORED = '[Content] Stored';
export const storeContent = payload => dispatch =>
  dispatch({ type: CONTENT_STORED, payload });
